import React from 'react'

const Team = () => (
  <div id='team' className='container text-center'>
    <div className='text-center'>
      <h3>Our local loan consultants</h3>
    </div>
    <div className='big grey'>
      <div className='d-inline d-md-block'>
        Our local team makes the process easy for you. Speak with us at a time that suits your schedule
      </div>
    </div>
    <div className='row justify-content-center mt-5 pt-2'>
      <div className='col-sm-10'>
        <div className='row align-content-center'>
          <div className='col-6 col-md-3'>
            <div className='team-member'>
              <div className='team-member-image team-member-image--karina'/>
              Karina
            </div>
          </div>
          <div className='col-6 col-md-3'>
            <div className='team-member'>
              <div className='team-member-image team-member-image--luke'/>
              Luke
            </div>
          </div>
          <div className='col-6 col-md-3'>
            <div className='team-member'>
              <div className='team-member-image team-member-image--sandy'/>
              Sandy
            </div>
          </div>
          <div className='col-6 col-md-3'>
            <div className='team-member'>
              <div className='team-member-image team-member-image--nathan'/>
              Nathan
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className='mt-4'/>
    <div className='buttons-container'>
      <span 
        className="btn btn-lg btn-green mr-sm-2 apply-now-btn" 
        onClick={ () => { Calendly.showPopupWidget('https://calendly.com/yard_au');return false; } }
        id="apply-now-btn"
        href='/onboarding_funnel/new'>
        Talk to an expert
      </span>
      <a 
        className="btn btn-lg btn-line-green ml-sm-2 view-rates-btn" 
        href='/pages/about'
        id="view-rates-btn">
        More about us
      </a>
    </div>
  </div>
);

export default Team
